import React, { useEffect } from "react";
import SingleSlider from "./SingleSlider";
import "./createSurvey.css";
import Navbar from "../../components/navbar/Navbar";
import Steps from "../../components/steps/Index";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/navbar/Footer";
import { useSelector, useDispatch } from "react-redux";
import { updateAnswer } from "../../redux/slices/questionsSlice";
import useSurveyAutosave from "../../hooks/useSurveyAutosave";
import NavigationHintBox from "../../components/NavigationHintBox";
// import SurveyLinkBox from "../../components/SurveyLinkBox";

export default function Step13() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const answers = useSelector((state) => state.questions.answers);
  const { areas } = useSelector((state) => state.areas);
  const questions = useSelector((state) => state.questions?.questions);
  const { saveSurveyProgress } = useSurveyAutosave();

  const startIndex = 60;
  const pageQuestions = questions.slice(startIndex, startIndex + 5);

  const sixthQuestion = questions?.find((question) => question.id == 77);

  const allQuestions = [...pageQuestions, sixthQuestion];

  // default answers
  useEffect(() => {
    allQuestions?.forEach((question) => {
      const question_id = `q${question.id}`;
      if (!answers[question_id]) {
        // const options = [45, 55, 65];
        // const randomValue = options[Math.floor(Math.random() * options.length)];
        dispatch(updateAnswer({ questionId: question_id, answer: 0 }));
      }
    });
  }, [pageQuestions, answers, dispatch]);

  const handleAnswerChange = (data) => {
    const questionId = data.id;
    const answer = data.value;
    const answerKey = `q${questionId}`;
    dispatch(updateAnswer({ questionId: answerKey, answer: answer }));
  };

  const handlePrevClick = () => {
    dispatch({ type: "STEP" });
    navigate("/step12");
  };
  const handleNextClick = async () => {
    dispatch({ type: "STEP" });
    await saveSurveyProgress(answers);
    navigate("/step14");
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Navbar />
      <div className="mainContainer" style={{ flex: 1 }}>
        <NavigationHintBox />
        <div className="surveys-sub-container">
          <Steps step={13} active={true} />
          <div className="inst-c">
            {/* <SurveyLinkBox /> */}
            <div className="survey-slider-container-title surveys-question-title">
              Reward/Goal Attainment
            </div>
          </div>
          <div className="survey-slider-container inst-sub-first">
            <div className="slider-all">
              {allQuestions?.map((question, index) => (
                <SingleSlider
                  key={question.id}
                  index={startIndex + index + 3} // start index is increment by 2 (new)
                  question={question}
                  pageQuestions={allQuestions}
                  handleAnswerChange={handleAnswerChange}
                  currentAnswer={answers[`q${question.id}`] || 0}
                />
              ))}
            </div>
          </div>
          <div className="btn-container gap-5">
            <Button
              onClick={handlePrevClick}
              className="signupCVbtnSign"
              variant="contained"
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                padding: "8px 30px",
                textTransform: "capitalize",
                borderRadius: "999px",
                backgroundColor: "#3F9BFD",
                "&:hover": { backgroundColor: "#3F9BFD" },
              }}
            >
              Back
            </Button>
            <Button
              onClick={handleNextClick}
              className="signupCVbtnSign"
              type="submit"
              variant="contained"
              style={{
                backgroundColor: "#3F9BFD",
              }}
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                padding: "8px 30px",
                borderRadius: "999px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#3F9BFD",
                },
              }}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
